module.exports = __webpack_public_path__ + "media/images/creator/home/about-03@2x-c6b6065ed61cb390500e4c745cd0f2c4.png";